export default __webpack_public_path__ + "static/falling-woman-b5f0792461077e29dc4497ba52a133a4.png";